import React from 'react';
import PropTypes from 'prop-types';
import { Transition as ReactTransition } from 'react-transition-group';
import Velocity from 'velocity-animate';
import classnames from 'classnames';

import Analytics from '@module/analytics';

export class Fakedoor extends React.PureComponent {
  state = {
    fakedoorVisible: false,
  };

  handleEscape = (event) => {
    if (event.key !== 'Escape') {
      return;
    }

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_take_me_to_free',
    });

    this.props.onEscape();
  };

  // Fade-out and scale up when the component is going away
  onExit(component) {
    Velocity(
      component,
      {
        scale: '1.3',
        opacity: 0,
      },
      { duration: 300 }
    );
  }

  componentDidMount() {
    window.addEventListener('keydown', this.handleEscape);

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'show_page',
    });
  }

  componentWillUnmount() {
    window.removeEventListener('keydown', this.handleEscape);
  }

  handleClick = () => {
    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_take_me_to_free',
    });
    this.props.onClick();
  };

  handleFakedoorClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_okay_got_it',
    });

    this.setState({ fakedoorVisible: false });
  };

  handleFreemiumClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_tell_me_about_free_accounts',
    });

    this.setState({ fakedoorVisible: true });
  };

  handleFreeClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_take_me_to_free',
    });
    this.props.onFreeClick();
  };

  handlePlusClick = (event) => {
    // Stop Triggering GA tracker in handleClick()
    event.stopPropagation();

    Analytics.trackStructEvent({
      category: 'splashscreen',
      action: 'click_get_wetransfer_plus',
    });
    this.props.onPlusClick('Splashpage_Fakedoor_blue');
  };

  renderContent() {
    return (
      <div className="splash-201708">
        <div className="splashpage__background" />

        <div className="content">
          <h1 className="content__heading">
            <span>Welcome to WeTransfer</span>
            <span>Which option fits you best? </span>
          </h1>

          <div className="content__plans">
            <div className="plan plan--free">
              <h2 className="plan__heading">WeTransfer</h2>
              <ul className="plan__features">
                <li>Send up to 1GB</li>
              </ul>
              <button
                className="button button--border"
                onClick={this.handleFreeClick}
              >
                Take me to free
              </button>
            </div>

            <div
              className={classnames('plan plan--freemium', {
                fakedoor__active: this.state.fakedoorVisible,
              })}
            >
              <h2 className="plan__heading">WeTransfer Account</h2>

              <ul className="plan__features">
                <li>Send up to 2GB</li>
                <li>Manage transfers</li>
                <li>Store up to 5GB</li>
              </ul>
              <button className="button" onClick={this.handleFreemiumClick}>
                Tell me about free accounts
              </button>
              <div
                className={classnames('fakedoor', {
                  fakedoor__active: this.state.fakedoorVisible,
                })}
                ref={this.fakedoor}
                onClick={this.handleFakedoorClick}
              >
                <div className="fakedoor__content">
                  Thanks for your interest.
                  <br />
                  WeTransfer Account will be up and running later this year.
                </div>
                <button
                  className="button button--border fakedoor__button"
                  onClick={this.handleFakedoorClick}
                >
                  Ok, got it
                </button>
              </div>
            </div>

            <div className="plan plan--plus">
              <h2 className="plan__heading">WeTransfer Plus</h2>
              <ul className="plan__features">
                <li>Send up to 20GB</li>
                <li>Manage transfers</li>
                <li>Store up to 100GB</li>
                <li>Your own backgrounds</li>
                <li>A custom URL</li>
                <li>Password-protect transfers</li>
              </ul>
              <button className="button" onClick={this.handlePlusClick}>
                Get Plus
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Render our splash page
  render() {
    return (
      <ReactTransition
        in={this.props.in}
        timeout={{ in: 0, exit: 300 }}
        unmountOnExit={true}
        onExit={this.onExit}
      >
        <div
          className="splashpage splashpage__experiment splashpage__experiment--fakedoor"
          onClick={this.handleClick}
        >
          {this.renderContent()}
        </div>
      </ReactTransition>
    );
  }
}

Fakedoor.propTypes = {
  in: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  onFreeClick: PropTypes.func.isRequired,
  onPlusClick: PropTypes.func.isRequired,
  onEscape: PropTypes.func.isRequired,
};

export default Fakedoor;
